import axios from 'axios';
import { serverUrl, baseUrl, adminUrl, workflowUrl, analyticsUrl, regulationUrl, regulationBookUrl, regulationApiUrl, finraUrl } from 'Config';
import AuthService from '../AuthService';
import Axios from 'axios-observable';


const reg_url = (base) => {
    const alt_regulation_root = 'https://rig-regulations-staging.azurewebsites.net';
    const rand_num = Math.floor((Math.random() * 100) + 1);
    console.log(rand_num, rand_num % 2 == 0)
    if (rand_num % 2 == 0) {
        console.log(base)
        return base;
    } else{
        return base.split('http://localhost:5030').join(alt_regulation_root).split('https://rig-staging.corlytics.com/regulations').join(alt_regulation_root)
    }
}

class HttpClient {
    constructor() { }

    headers() {
        if (AuthService.isLoggedIn()) {
            return {
                'Authorization': 'Bearer ' + AuthService.getToken(),
                'Pragma': 'no-cache'
            };
        }
        return ''
    }

    download(url, data) {
        return Axios.request({
            method: 'POST',
            url: serverUrl + url,
            data: data,
            headers: this.headers(),
            responseType: 'blob'
        });
    }

    get(url, admin = false) {
        if (admin) {
            return Axios.request({
                method: 'GET',
                url: adminUrl + url,
                headers: this.headers()
            });
        } else {
            return Axios.request({
                method: 'GET',
                url: serverUrl + url,
                headers: this.headers()
            });
        }
    }

    post(url, data) {
        return Axios.request({
            method: 'POST',
            url: serverUrl + url,
            data: data,
            headers: this.headers()
        });
    }

    put(url, data) {
        return Axios.request({
            method: 'PUT',
            url: serverUrl + url,
            data: data,
            headers: this.headers()
        });
    }

    delete(url) {
        return Axios.request({
            method: 'DELETE',
            url: serverUrl + url,
            headers: this.headers()
        });
    }

    workflowGet(url) {
        return Axios.request({
            method: 'GET',
            url: workflowUrl + url,
            headers: this.headers()
        });
    }

    workflowGetPDF(url) {
        return Axios.request({
            method: 'GET',
            url: workflowUrl + url,
            headers: { ...this.headers(), 'Accept': 'aplication/pdf' },
            responseType: 'blob'
        });
    }

    workflowDelete(url) {
        return Axios.request({
            method: 'DELETE',
            url: workflowUrl + url,
            headers: this.headers()
        });
    }

    workflowPost(url, data) {
        return Axios.request({
            method: 'POST',
            url: workflowUrl + url,
            data: data,
            headers: this.headers()
        });
    }

    workflowPut(url, data) {
        return Axios.request({
            method: 'PUT',
            url: workflowUrl + url,
            data: data,
            headers: this.headers()
        });
    }

    analyticGet(url) {
        return Axios.request({
            method: 'GET',
            url: analyticsUrl + url,
            headers: this.headers()
        });
    }

    analyticDelete(url) {
        return Axios.request({
            method: 'DELETE',
            url: analyticsUrl + url,
            headers: this.headers()
        });
    }

    analyticPost(url, data) {
        return Axios.request({
            method: 'POST',
            url: analyticsUrl + url,
            data: data,
            headers: this.headers()
        });
    }

    analyticPut(url, data) {
        return Axios.request({
            method: 'PUT',
            url: analyticsUrl + url,
            data: data,
            headers: this.headers()
        });
    }

    adminGet(url) {
        return Axios.request({
            method: 'GET',
            url: adminUrl + url,
            headers: this.headers()
        });
    }

    adminDelete(url) {
        return Axios.request({
            method: 'DELETE',
            url: adminUrl + url,
            headers: this.headers()
        });
    }

    adminPost(url, data) {
        return Axios.request({
            method: 'POST',
            url: adminUrl + url,
            data: data,
            headers: this.headers()
        });
    }

    adminPut(url, data) {
        return Axios.request({
            method: 'PUT',
            url: adminUrl + url,
            data: data,
            headers: this.headers()
        });
    }

    regulationGet(url) {
        return Axios.request({
            method: 'GET',
            url: reg_url(regulationUrl) + url,
            headers: this.headers()
        });
    }

    regulationDelete(url) {
        return Axios.request({
            method: 'DELETE',
            url: reg_url(regulationUrl) + url,
            headers: this.headers()
        });
    }

    regulationPost(url, data) {
        return Axios.request({
            method: 'POST',
            url: reg_url(regulationUrl) + url,
            data: data,
            headers: this.headers()
        });
    }

    regulationPut(url, data) {
        return Axios.request({
            method: 'PUT',
            url: reg_url(regulationUrl) + url,
            data: data,
            headers: this.headers()
        });
    }

    regulationBookGet(url) {
        return Axios.request({
            method: 'GET',
            url: reg_url(regulationBookUrl) + url,
            headers: this.headers()
        });
    }

    regulationBookDelete(url) {
        return Axios.request({
            method: 'DELETE',
            url: reg_url(regulationBookUrl) + url,
            headers: this.headers()
        });
    }

    regulationBookPost(url, data) {
        return Axios.request({
            method: 'POST',
            url: reg_url(regulationBookUrl) + url,
            data: data,
            headers: this.headers()
        });
    }

    regulationBookPut(url, data) {
        return Axios.request({
            method: 'PUT',
            url: reg_url(regulationBookUrl) + url,
            data: data,
            headers: this.headers()
        });
    }

    publicPost(url, data) {

        return Axios.request({
            method: 'POST',
            url: baseUrl + url,
            data: data
        });
    }

    apiGet(url) {
        const headers = this.headers();

        return Axios.request({
            method: 'GET',
            url: reg_url(regulationApiUrl) + url,
            headers: headers
        });
    }

    // Finra requests
    finraGet(url) {
        return Axios.request({
            method: 'GET',
            url: finraUrl + url,
            headers: this.headers()
        });
    }
    finraPost(url, data) {
        return Axios.request({
            method: 'POST',
            url: finraUrl + url,
            data: data,
            headers: this.headers()
        });
    }
    finraPut(url, data) {
        return Axios.request({
            method: 'PUT',
            url: finraUrl + url,
            data: data,
            headers: this.headers()
        });
    }
    finraDelete(url) {
        return Axios.request({
            method: 'DELETE',
            url: finraUrl + url,
            headers: this.headers()
        });
    }
    finraDownload(url) {
        return Axios.request({
            method: 'GET',
            url: finraUrl + url,
            headers: this.headers(),
            responseType: 'blob'
        });
    }

    servicesPut(url, data) {
        return Axios.request({
            method: 'PUT',
            url: url,
            data: data,
            headers: this.headers()
        });
    }
}

export default new HttpClient();


// WEBPACK FOOTER //
// ./src/services/REST/HttpClient.js